export default __webpack_public_path__ + "07b72365e03bd16ea8e759dcb29e2115.png";